<template>
  <section class="hero reveal visible" id="home">
    <div class="hero-bg">
      <div class="hero-gradient-1"></div>
      <div class="hero-gradient-2"></div>
      <div class="hero-gradient-3"></div>
      <div class="hero-grid-pattern"></div>
      <div class="hero-noise"></div>
    </div>
    <div class="container hero-content">
      <div class="hero-badge reveal-delay-1 reveal visible">
        <span class="badge-dot"></span>
        {{ $store.getters.t('hero.badge') }}
      </div>
      <h1 class="hero-title reveal-delay-2 reveal visible">
        {{ $store.getters.t('hero.title') }}
      </h1>
      <p class="hero-subtitle reveal-delay-2 reveal visible">
        {{ $store.getters.t('hero.subtitle') }}
      </p>
      <p class="hero-desc reveal-delay-3 reveal visible">
        {{ $store.getters.t('hero.desc') }}
      </p>
      <div class="hero-actions reveal-delay-3 reveal visible">
        <a :href="$store.getters.t('hero.cta1Link')" target="_blank" class="btn btn-primary btn-lg">
          {{ $store.getters.t('hero.cta1') }}
          <svg width="18" height="18" viewBox="0 0 18 18"><path d="M7 4l6 5-6 5" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </a>
        <a href="#products" class="btn btn-outline btn-lg" @click.prevent="scrollTo('products')">
          {{ $store.getters.t('hero.cta2') }}
        </a>
      </div>
      <div class="hero-stats reveal-delay-4 reveal visible">
        <div class="hero-stat" v-for="(stat, i) in heroStats" :key="i">
          <span class="stat-num">{{ stat.num }}</span>
          <span class="stat-label">{{ stat.label }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection',
  computed: {
    heroStats() {
      const t = (k) => this.$store.getters.t(k)
      return [
        { num: t('hero.stat1'), label: t('hero.stat1Label') },
        { num: t('hero.stat2'), label: t('hero.stat2Label') },
        { num: t('hero.stat3'), label: t('hero.stat3Label') },
        { num: t('hero.stat4'), label: t('hero.stat4Label') }
      ]
    }
  },
  methods: {
    scrollTo(id) {
      const el = document.getElementById(id)
      if (el) el.scrollIntoView({ behavior: 'smooth' })
    }
  }
}
</script>

<style scoped>
.hero {
  min-height: 100vh;
  display: flex;
  align-items: center;
  padding: 160px 0 100px;
  position: relative;
  overflow: hidden;
}
.hero-bg { position: absolute; inset: 0; pointer-events: none; }
.hero-gradient-1 {
  position: absolute;
  top: -30%; left: -15%;
  width: 70%; height: 80%;
  background: radial-gradient(ellipse, rgba(59,130,246,.14) 0%, transparent 70%);
  animation: heroFloat1 12s ease-in-out infinite;
}
.hero-gradient-2 {
  position: absolute;
  bottom: -30%; right: -15%;
  width: 60%; height: 70%;
  background: radial-gradient(ellipse, rgba(99,102,241,.1) 0%, transparent 70%);
  animation: heroFloat2 14s ease-in-out infinite reverse;
}
.hero-gradient-3 {
  position: absolute;
  top: 40%; left: 30%;
  width: 40%; height: 40%;
  background: radial-gradient(ellipse, rgba(6,182,212,.06) 0%, transparent 60%);
  animation: heroFloat1 16s ease-in-out infinite;
}
@keyframes heroFloat1 {
  0%, 100% { transform: translate(0, 0) scale(1) rotate(0deg); }
  33% { transform: translate(20px, -30px) scale(1.06) rotate(1deg); }
  66% { transform: translate(-10px, 20px) scale(0.95) rotate(-1deg); }
}
@keyframes heroFloat2 {
  0%, 100% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(-30px, 20px) scale(1.08); }
}
.hero-grid-pattern {
  position: absolute; inset: 0;
  background-image:
    linear-gradient(rgba(255,255,255,.015) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255,255,255,.015) 1px, transparent 1px);
  background-size: 64px 64px;
  mask-image: radial-gradient(ellipse at center, black 30%, transparent 80%);
}
.hero-noise {
  position: absolute; inset: 0;
  opacity: .015;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.8' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E");
  background-size: 256px;
}
.hero-content {
  position: relative;
  z-index: 1;
  text-align: center;
  max-width: 920px;
}
.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 20px;
  background: rgba(59,130,246,.1);
  border: 1px solid rgba(59,130,246,.2);
  border-radius: 24px;
  font-size: 13.5px;
  font-weight: 500;
  color: #60a5fa;
  margin-bottom: 28px;
  letter-spacing: .02em;
}
.badge-dot {
  width: 8px; height: 8px;
  background: #3b82f6;
  border-radius: 50%;
  box-shadow: 0 0 10px rgba(59,130,246,.5);
  animation: pulseD 2.5s ease infinite;
}
@keyframes pulseD {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: .4; transform: scale(1.3); }
}
.hero-title {
  font-size: clamp(34px, 5.5vw, 58px);
  font-weight: 800;
  line-height: 1.15;
  background: linear-gradient(135deg, #f8fafc 0%, #cbd5e1 40%, #f8fafc 70%, #94a3b8 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 18px;
  letter-spacing: -.01em;
}
.hero-subtitle {
  font-size: clamp(16px, 2vw, 20px);
  color: #60a5fa;
  margin-bottom: 18px;
  font-weight: 400;
  letter-spacing: .01em;
}
.hero-desc {
  font-size: 15px;
  color: #64748b;
  line-height: 1.8;
  max-width: 680px;
  margin: 0 auto 40px;
}
.hero-actions {
  display: flex;
  gap: 14px;
  justify-content: center;
  margin-bottom: 72px;
  flex-wrap: wrap;
}
.btn-lg {
  padding: 14px 32px;
  font-size: 15px;
  border-radius: 10px;
  gap: 8px;
}
.btn-lg.btn-primary svg { color: rgba(255,255,255,.7); }
.hero-stats {
  display: flex;
  justify-content: center;
  gap: clamp(32px, 6vw, 72px);
  flex-wrap: wrap;
}
.hero-stat {
  text-align: center;
  position: relative;
}
.hero-stat:not(:last-child)::after {
  content: '';
  position: absolute;
  right: -36px;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 40px;
  background: linear-gradient(to bottom, transparent, rgba(255,255,255,.08), transparent);
}
.stat-num {
  display: block;
  font-size: clamp(28px, 4vw, 38px);
  font-weight: 800;
  background: linear-gradient(135deg, #93c5fd, #3b82f6, #2563eb);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -.02em;
  line-height: 1;
}
.stat-label {
  font-size: 13px;
  color: #64748b;
  margin-top: 8px;
  font-weight: 500;
  letter-spacing: .01em;
}

@media (max-width: 768px) {
  .hero { padding: 140px 0 60px; }
  .hero-actions { margin-bottom: 56px; }
  .hero-stat:not(:last-child)::after { display: none; }
  .hero-stats { gap: 28px; }
}
</style>
